export default __webpack_public_path__ + "static/annette-56d32a9d4a5f70256ca5fd02cfce4be1.svg";